import { useLocation } from 'react-router-dom';

import PillButtonContainer from 'components/buttons/PillButtonContainer';
import CloseIcon from 'components/icons/CloseIcon';
import NavigationText from 'components/text/NavigationText';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const MobileDrawerMenuButton: FunctionComponent<Props> = ({
    className = '',
    isOpen,
    onClick,
    testId = TEST_ID
}) => {
    const location = useLocation();
    const { CLOSE_SIDEBAR, HOME, ORG } = useTranslation();

    const currentRoute = location.pathname.split('/').pop();

    const buttonText = isOpen ? CLOSE_SIDEBAR : `${ORG}/${currentRoute || HOME}`;

    return (
        <PillButtonContainer
            className={`${className} ${styles.mobileDrawerMenuButton}`}
            onClick={onClick}
            testId={testId}>
            <NavigationText className={styles.navigationText}>{buttonText}</NavigationText>

            {isOpen && <CloseIcon className={styles.closeIcon} />}
        </PillButtonContainer>
    );
};

export default MobileDrawerMenuButton;
